import axios from 'axios';
import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_CANCEL_PLAN = 'GET_CANCEL_PLAN';
export const GET_CANCEL_PLAN_SUCCESS = 'GET_CANCEL_PLAN_SUCCESS';
export const GET_CANCEL_PLAN_FAILURE = 'GET_CANCEL_PLAN_FAILURE';

// Action Creators
export const getCancelRequest = () => ({
  type: GET_CANCEL_PLAN,
});

export const getCancelSuccess = (users) => ({
  type: GET_CANCEL_PLAN_SUCCESS,
  payload: users,
});

export const getCancelFailure = (error) => ({
  type: GET_CANCEL_PLAN_FAILURE,
  payload: error,
});

// Thunk Function
export const postCancel = (external, body) => {
  return async (dispatch) => {
    dispatch(getCancelRequest());
    try {
      const response = await postMethodWithToken(url?.cancelPlan, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getCancelSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getCancelFailure(error?.message));
    }
  };
};
